<template>
    <div>
        <!-- S 头部 -->
        <div class="header">
            <div class="inner">
                <a class="site_logo" href=""><img src="static/images/pinyuelogo.png" width="200" style="margin: -25px 0 0 0;"/></a>
            </div>
        </div>
        <!-- E 头部 -->
        <!--S 本页容器-->
        <div class="main_wrap">
            <div class="login_content">
                <div class="login_top">找回密码</div><div id="reg">已有账号，<router-link to="/admin/login" class="denglu">登录</router-link></div>
                <input name="user_name" class="telephone" type="text" maxlength="13" placeholder="请输入手机号" v-model="formData.phone_mob">
                <div class="code_line">
                    <input class="code" type="text" name="captcha" maxlength="6" placeholder="短信验证码" v-model="formData.verifyCode"/>
                    <el-button type="success" class="get-code" @click="checkImgCode" :disabled="btnDisabled">{{btnText}}</el-button>
                </div>
                <input class="password" type="password" placeholder="请输入新密码" v-model="formData.password">
                <input class="password" type="password" placeholder="确认新密码" v-model="formData.confirmPassword">
                <input id="rurl_txt" type="hidden" name="ret_url" value="">
                <input class="login_btn" type="button" value="提交" @click="handleReg">
                <div class="login_footer">
                    <!-- <div id="loginWX" class="weixin">
                        <i class="icon icon_wx"></i>
                        <span class="text">微信登录</span>
                    </div> -->
                    <div id="loginQQ" class="qq">
                        <span class="text" id="qqLoginBtn"></span>
                    </div>
                    <!--<div class="find_password"><a href="">忘记密码？点此重置密码</a></div>-->
                </div>
            </div>
        </div>
        <!--E 本页容器-->
        <!-- S 底部 -->
        <div class="footer">
            <div class="footer_inner">
                <p class="copyright">
                    Copyright © 2008-2019 <a href="http://www.lypinyue.cn/">品越会员管理系统</a> 豫ICP备12001965号-2
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    export default {
        name: "find-password",
        data(){
            return {
                captchaUrl:this.mobileDomain+'/site/captcha',
                baseCaptchaUrl:this.mobileDomain+'/site/captcha',
                formData:{

                },
                i:60,
                si:'',
                btnText:'获取验证码',
                btnDisabled:false
            }
        },
        methods:{
            changeCaptcha(){
                this.captchaUrl = this.captchaUrl+'';
            },
            getStore(userId){
                var _this = this;
                this.$http.get('/v1/store/get-store',{params:{userId:userId}}).then((res) => {
                    //console.log(res.data)
                    if (res.data.errcode == 1) {
                        location.href = _this.pcDomainUrl+'/index.php?app=apply';
                    } else {
                        /*if (res.data.state == 0){
                            location.href = _this.pcDomainUrl+'/index.php?app=store&id='+res.data.id;
                        }else {*/
                        _this.$store.commit('setStore', res.data)
                        _this.$router.push('/admin/home')
                        //}
                    }
                })
            },
            checkImgCode(){
                var _this = this;
                /*if (!this.formData.imgCode){
                    Dialog.alert({
                        message:'图片验证码为空'
                    })
                    return false;
                }*/
                if (!this.formData.phone_mob){
                    this.$alert('手机号码为空');
                    return false;
                }
                this.$http.post('/v1/send-sms/send',{mobile:this.formData.phone_mob,type:'reg'}).then((res)=>{
                    if (res.data.errcode == 1){
                        _this.$alert(res.data.msg)
                    }else {
                        this.$nextTick(()=>{
                            this.si = setInterval(_this.countDown, 1000);
                        })
                    }
                })
            },
            countDown(){
                var _this = this.$refs.btnCode;
                //console.log(_this);
                this.i--;
                if (this.i < 0) {
                    this.btnText = '重新获取';
                    this.btnDisabled = false
                    clearInterval(this.si);
                    this.i = 60;
                    return;
                } else {
                    this.btnText = '等待' + this.i + "秒";
                    this.btnDisabled = true
                }
            },
            handleReg(){
                if (!this.formData.phone_mob){
                    this.$alert('手机号为空');
                    return false;
                }
                if (!this.formData.password){
                    this.$alert('密码不能为空');
                    return false;
                }
                if (!this.formData.verifyCode){
                    this.$alert('短信验证码不能为空');
                    return false;
                }
                if (this.formData.password != this.formData.confirmPassword) {
                    this.$alert('两次输入的密码不一致');
                    return false;
                }
                /*if (!this.formData.imgCode){
                    this.errors.push('图片验证码不能为空')
                    this.captcha = this.apiUrl+'/site/captcha?v='+new Date().getTime();
                    return false;
                }*/
                this.formData.referer = 'store'
                var _this = this;
                this.$http.post('/v1/user/find-password/',this.formData).then(function (res) {
                    if (res.data.errcode == 0){
                        Cookies.set('access_token',res.data.access_token)
                        Cookies.set('user_id',res.data.user_id)
                        if (!res.data.storeId) {

                        }else {
                            Cookies.set('storeId',res.data.storeId)
                        }
                        _this.$alert(res.data.msg)
                        _this.$router.push('/admin/login');
                    }else {
                        this.$alert(res.data.msg)
                    }
                });
            }
        }
    }
</script>

<style scoped>

    .main_wrap{
        background: url('/static/images/login-banner.png');
    }
    .get-code{
        margin:0 0 0 10px;
    }
    .denglu{
        color: #008bcc;
    }
</style>
